import { darkTheme } from '../../../lib/tokens';
import type { PipelineStage } from '../data/types';

interface StageFlowProps {
  stages: PipelineStage[];
  activeId?: string;
  onSelect?: (id: string) => void;
}

/**
 * Die Kette der Stufen als Uebersicht. Waagerecht mit eigenem Ueberlauf —
 * die Seite selbst darf nie waagerecht scrollen, die Kette schon.
 */
export function StageFlow({ stages, activeId, onSelect }: StageFlowProps): JSX.Element {
  return (
    <nav aria-label="Stufen der Strecke" className="-mx-1 overflow-x-auto px-1 pb-2">
      <ol className="flex min-w-max items-stretch gap-2">
        {stages.map((stage, i) => (
          <li key={stage.id} className="flex items-stretch gap-2">
            <button
              type="button"
              onClick={() => onSelect?.(stage.id)}
              aria-current={activeId === stage.id ? 'step' : undefined}
              className="flex w-44 flex-col rounded-md border p-3 text-left transition-colors hover:border-accent-light"
              style={{
                background: activeId === stage.id ? darkTheme.colors.accentSubtle : darkTheme.colors.bgSurface,
                borderColor: activeId === stage.id ? darkTheme.colors.accent : darkTheme.colors.borderSubtle,
              }}
            >
              <span
                className="text-[10px] font-bold uppercase tracking-widest"
                style={{ color: darkTheme.colors.accentLight }}
              >
                Stufe {stage.nr}
              </span>
              <span className="mt-1 text-sm font-semibold text-text-primary">{stage.title}</span>
              <span className="mt-1 line-clamp-3 text-xs text-text-secondary">{stage.purpose}</span>
            </button>
            {i < stages.length - 1 && (
              <span aria-hidden className="flex items-center text-text-tertiary">
                →
              </span>
            )}
          </li>
        ))}
      </ol>
    </nav>
  );
}
